var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4875 17.9557C17.78 17.6624 18.2549 17.6618 18.5482 17.9543L22.0722 21.4692C22.3655 21.7617 22.3661 22.2366 22.0736 22.5299C21.7811 22.8231 21.3062 22.8238 21.0129 22.5312L17.4889 19.0164C17.1956 18.7239 17.195 18.249 17.4875 17.9557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7669 3.52832C7.21685 3.52832 3.52832 7.21685 3.52832 11.7669C3.52832 16.3169 7.21685 20.0054 11.7669 20.0054C16.3169 20.0054 20.0054 16.3169 20.0054 11.7669C20.0054 7.21685 16.3169 3.52832 11.7669 3.52832ZM2.02832 11.7669C2.02832 6.38842 6.38842 2.02832 11.7669 2.02832C17.1453 2.02832 21.5054 6.38842 21.5054 11.7669C21.5054 17.1453 17.1453 21.5054 11.7669 21.5054C6.38842 21.5054 2.02832 17.1453 2.02832 11.7669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.1f260ce549a3699697dbfc2157c1260a.svg";
export { ForwardRef as ReactComponent };